import React from 'react';
import {useTranslation} from 'react-i18next';

const Faq = () => {
    const {t} = useTranslation();
    const items = [0, 1, 2, 3].map(i => ({q: t(`design.faq.${i}.q`), a: t(`design.faq.${i}.a`)}));
    return (
        <section id="faq" className="design-section">
            <div className="design-container faq-grid">
                <div><h2>{t('design.faq')}</h2><p className="section-subtitle">{t('design.faqSubtitle')}</p></div>
                <div className="faq-card">
                    {items.map(({q, a}) => <details key={q}><summary>{q}<span aria-hidden="true">+</span></summary><p>{a}</p></details>)}
                </div>
            </div>
        </section>
    );
};
export default Faq;
